// extracted by mini-css-extract-plugin
export var phone = "_1w-0";
export var phoneDragging = "_1w-1";